export default {
  startingFrom: {
    id: 'card_starting_from',
    defaultMessage: 'Starting from',
  },
  addToCart: {
    id: 'card_add_to_cart',
    defaultMessage: 'Add to cart',
  },
  tinyAddToCart: {
    id: 'card_tiny_add_to_cart',
    defaultMessage: 'Add',
  },
  productCardWarranty: {
    id: 'pthumbs_warranty_new',
    defaultMessage: 'Warranty: {warranty}',
  },
  gradeDescription: {
    id: 'product_card_condition',
    defaultMessage: 'Condition: {grade}',
  },
  colorSwatches: {
    id: 'color_swatches_label',
    defaultMessage: 'Color: {color}',
  },
  moreColors: {
    id: 'color_swatches_more',
    defaultMessage: 'more colors',
  },
  colorsLabel: {
    id: 'color_label',
    defaultMessage: 'Colors: ',
  },
  moreStorages: {
    id: 'storages_swatches_more',
    defaultMessage: 'more storages',
  },
  storageLabel: {
    id: 'storage_label',
    defaultMessage: 'Storage: ',
  },
}
